import React from "react";
import {
  List,
  Datagrid,
  TextField,
  Create,
  SimpleForm,
  TextInput,
  Edit,
  EditButton,
  Delete,
  Filter,
  DateInput,
  DateField,
  ReferenceInput,
  SelectInput,
  ReferenceField,
  NumberInput,
  Show,
  SimpleShowLayout,
  NumberField,
  DateTimeFormat
} from "admin-on-rest/lib/mui";

import LinkToRelatedQuestions from "./custom/LinkToRelatedQuestions";
import { Actions } from "../custom/actions";
import { RichTextField } from "admin-on-rest";
//import SubGenreInput  from './custom/SubGenreInput';
//import { DependentInput } from 'aor-dependent-input';
//var randomstring = require("randomstring");

// function generate(){
//
//   return randomstring.generate({
//       length: 6,
//       charset: 'numeric'
//   });
// }
const userType = localStorage.getItem("permissions");

export const SurveyFilter = props => (
  <Filter {...props}>
    <TextInput label="resources.title.name" source="title" alwaysOn />
    <DateInput
      label="resources.expiration_day.name"
      source="ends_on"
      alwaysOn
    />
    <ReferenceInput
      label="resources.companies.name"
      source="CompanyID"
      reference="companies"
      allowEmpty
      alwaysOn
      perPage={1000}
    >
      <SelectInput optionText={choice => `${choice.name}`} />
    </ReferenceInput>
    <ReferenceInput
      label="resources.branches.name"
      source="BranchID"
      reference="branches"
      allowEmpty
      alwaysOn
      perPage={1000}
    >
      <SelectInput
        optionText={choice => `${choice.tmima + " " + choice.address}`}
      />
    </ReferenceInput>
  </Filter>
);

export const SurveysList = props => (
  <List
    {...props}
    actions={<Actions />}
    filters={<SurveyFilter />}
    title="Διαχείριση Quiz Box"
    sort={{ field: "created_on", order: "DESC" }}
  >
    <Datagrid key={props._id}>
      <DateField label="resources.start_day.name" source="created_on" />
      <RichTextField label="resources.title.name" source="title" />
      <TextField source="code" />
      <DateField label="resources.expiration_day.name" source="ends_on" />
      {userType === "SuperUser" && (
        <ReferenceField
          linkType="none"
          label="resources.companies.name"
          source="CompanyID"
          reference="companies"
        >
          <TextField source="name" />
        </ReferenceField>
      )}
      <ReferenceField
        linkType="none"
        label="resources.branches.name"
        source="BranchID"
        reference="branches"
      >
        <TextField source="tmima_address" />
      </ReferenceField>
      <LinkToRelatedQuestions />
      <EditButton />
    </Datagrid>
  </List>
);

export const CreateSurvey = props => (
  <Create {...props}>
    <SimpleForm redirect="list">
      <TextInput label="resources.title.name" source="title" />
      <DateInput label="resources.expiration_day.name" source="ends_on" />
      <NumberInput label="resources.participation.name" source="limit" />

      {userType === "SuperUser" && (
        <ReferenceInput
          label="resources.companies.name"
          source="CompanyID"
          reference="companies"
          allowEmpty
        >
          <SelectInput optionText={choice => `${choice.name}`} />
        </ReferenceInput>
      )}

      {
        //  <DependentInput dependsOn="CompanyID" >
        //  <TextField label="Υποκατάστημα" />
        //  <SubGenreInput />
        // </DependentInput>
      }

      {
        //<DisabledInput defaultValue={generate()} label="Κωδικός" source="code" />
      }

      <ReferenceInput
        label="resources.branches.name"
        source="BranchID"
        reference="branches"
        allowEmpty
        alwaysOn
        perPage={1000}
      >
        <SelectInput
          optionText={choice => `${choice.tmima + " " + choice.address}`}
        />
      </ReferenceInput>
    </SimpleForm>
  </Create>
);

const PostTitle = ({ record }) => {
  return <span>{record ? `` : ""}</span>;
};

export const showSurvey = props => (
  <Show title={<PostTitle />} {...props}>
    <SimpleShowLayout>
      <TextField source="title" />
      <DateField source="ends_on" />
      <NumberField source="limit" />
      <TextField source="code" />
    </SimpleShowLayout>
  </Show>
);

// export const EditSurvey = (props) => (
//   <Edit title={<PostTitle />} {...props}>
//   <TabbedForm >
//       <FormTab label="γενικα">
//     <TextInput label="Τίτλος έρευνας" source="title" />
//     <DateInput label="Ημερομηνία λήξης" source="ends_on" options={{
//     minDate: new Date(),
//     DateTimeFormat,
//     okLabel: 'OK'}}/>
//     <NumberInput label="Μέγ. αριθμός συμμετεχόντων" source="limit"  />
//     <TextField source="code" />
//
//     <ReferenceInput label="Υποκαταστήμα" source="BranchID" reference="branches" allowEmpty >
//     <SelectInput optionText={choice => `${choice.address}`} />
//     </ReferenceInput>
//
//     <LinkToRelatedQuestions />
//     </FormTab>
//   <FormTab label="Απαντησεις">
//         {//<ShowPie source="results" />
//       }
//
//   </FormTab>
//     </TabbedForm>
//   </Edit>
// );

export const EditSurvey = props => (
  <Edit title={<PostTitle />} {...props}>
    <SimpleForm>
      <TextInput label="resources.title.name" source="title" />
      <DateInput
        label="resources.expiration_day.name"
        source="ends_on"
        options={{
          minDate: new Date(),
          DateTimeFormat,
          okLabel: "OK"
        }}
      />
      <NumberInput label="resources.participation.name" source="limit" />
      <TextField source="code" />

      <ReferenceInput
        label="resources.branches.name"
        source="BranchID"
        reference="branches"
        allowEmpty
      >
        <SelectInput optionText={choice => `${choice.address}`} />
      </ReferenceInput>

      <LinkToRelatedQuestions />
    </SimpleForm>
  </Edit>
);

const DeleteTitle = ({ record }) => {
  return <span>{record ? `Διαγραφή του ${record.title}` : ""}</span>;
};

export const DeleteSurvey = props => (
  <Delete title={<DeleteTitle />} {...props} />
);



// WEBPACK FOOTER //
// ./src/pages/surveys.js